import { SING_COLORS } from '@/constants/marketing-display.constants';
import type { LucideIcon } from 'lucide-react';
import { Calendar, CheckCircle, DollarSign, FileText, Settings, User } from 'lucide-react';

export interface SectionConfig {
  title: string;
  color: string;
  icon: LucideIcon;
  defaultOpen: boolean;
}

/**
 * Configuration visuelle des sections de review
 */
export const SECTION_CONFIGS: Record<string, SectionConfig> = {
  client: {
    title: 'Informations Client',
    color: SING_COLORS.BLUE,
    icon: User,
    defaultOpen: true,
  },
  reservation: {
    title: 'Détails de la Réservation',
    color: SING_COLORS.MAGENTA,
    icon: Calendar,
    defaultOpen: true,
  },
  options: {
    title: 'Options & Services',
    color: SING_COLORS.GOLD,
    icon: Settings,
    defaultOpen: true,
  },
  financier: {
    title: 'Informations Financières',
    color: SING_COLORS.DARK,
    icon: DollarSign,
    defaultOpen: true,
  },
  documents: {
    title: 'Documents',
    color: SING_COLORS.BURGUNDY,
    icon: FileText,
    defaultOpen: true,
  },
  validation: {
    title: 'Validation',
    color: SING_COLORS.BLUE,
    icon: CheckCircle,
    defaultOpen: true,
  },
};
